import React, { useEffect, useState, useMemo } from 'react';
import { Form, Button, DatePicker } from 'antd';
import { formatDate, getDisabledDates } from 'utils';
import { requiredRule } from 'utils/forms/validationRules';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';
import dayjs from 'dayjs';

function PaidVacationForm({ initialValues, disableDate, onSubmit, children }) {
  const [form] = Form.useForm();
  const [dateRange, setDateRange] = useState(null);

  useEffect(() => {
    if (initialValues) {
      const { worker_id, begin_date, end_date, payment_date } = initialValues;

      form.setFieldsValue({
        worker_id,
        date: [dayjs(begin_date), dayjs(end_date)],
        payment_date: dayjs(payment_date),
      });

      setDateRange([dayjs(begin_date), dayjs(end_date)]);
    }
  }, [initialValues]);

  const daysRange = useMemo(() => {
    if (dateRange?.length) {
      const [begin, end] = dateRange;

      return dayjs(end).diff(dayjs(begin), 'days');
    }

    return 0;
  }, [dateRange]);

  const disabledPaymentDate = (currentDate) => {
    if (dateRange?.length) {
      return (
        currentDate && currentDate > dayjs(dateRange[0]).subtract(3, 'days')
      );
    }

    return null;
  };

  const handleSubmit = async (values) => {
    const [begin, end] = values.date;

    const payload = {
      ...values,
      begin_date: formatDate(begin, 'YYYY-MM-DD'),
      end_date: formatDate(end, 'YYYY-MM-DD'),
      payment_date: formatDate(values?.payment_date, 'YYYY-MM-DD'),
      vacation_date_cnt: daysRange,
    };

    delete payload.date;

    const isSubmitted = await onSubmit(payload);

    if (isSubmitted) {
      form.resetFields();
      setDateRange(null);
    }
  };

  return (
    <Form
      form={form}
      onFinish={handleSubmit}
      layout="horizontal"
      labelCol={{
        span: LABEL_SPAN,
      }}
      wrapperCol={{ span: CONTENT_SPAN }}
      labelAlign="right"
    >
      {children}

      <Form.Item
        name="date"
        label="Дата начала и окончания"
        rules={[requiredRule]}
      >
        <DatePicker.RangePicker
          allowClear
          format="DD.MM.YYYY"
          disabledDate={getDisabledDates(disableDate)}
          style={{ width: '100%' }}
          onChange={setDateRange}
        />
      </Form.Item>

      <Form.Item
        name="payment_date"
        label="Дата начисления"
        rules={[requiredRule]}
      >
        <DatePicker
          allowClear
          format="DD.MM.YYYY"
          disabledDate={disabledPaymentDate}
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
        <Button type="primary" htmlType="submit">
          Сохранить
        </Button>
      </Form.Item>
    </Form>
  );
}

export { PaidVacationForm };
